<template>
    <!-- <l-control :position="position" :class="controlClass"> -->
    <golia-button v-if="!buttonInPanel"
        :class="['d-flex align-items-center justify-content-center freight-exchange-control', buttonClass]"
        :icon="`fa-regular ${disabled ? 'fa-magnifying-glass-minus' : 'fa-search'}`" @click.stop="handleClick" />
    <golia-button v-else variant="btn-fill dark-blue-1 text-white text-smaller mb-2"
        :class="`w-100 ${disabled ? 'opacity-50' : ''}`" @click="handleClick"
        :icon="`fa-regular ${disabled ? 'fa-magnifying-glass-minus' : 'fa-search'}`"
        :label="__('freight_exchange.search_here')" />
    <!-- :label="__('freight_exchange.search_here')"
    class="w-100" -->
    <!-- <a href="javascript:;" @click="handleClick"
        class="d-flex align-items-center justify-content-center cursor-pointer freight-exchange-control">
        <i class="fa-regular fa-radar"></i>
    </a> -->
    <!-- </l-control> -->
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mapConfig } from '@/composables/useConfig'

export default {
    name: 'FreightExchangeControl',
    components: {
        // LControl
    },
    props: {
        // Posizione del controllo sulla mappa
        position: {
            type: String,
            default: 'topleft',
            validator: (value) =>
                ['topleft', 'topright', 'bottomleft', 'bottomright'].includes(value)
        },
        // Tooltip al passaggio del mouse
        tooltip: {
            type: String,
            default: ''
        },
        // Condizione di visibilità
        visible: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // Classi CSS aggiuntive per il bottone
        buttonClass: {
            type: String,
            default: 'bg-white'
        },
        // Location
        location: {
            type: Object,
            default: () => ({
                lat: null,
                lng: null,
                radius: null
            })
        },
        buttonInPanel: {
            type: Boolean,
            default: false
        },
        // Filtri correnti ricavati dalla form (non “storicizzati”)
        formFilters: {
            type: Object,
            default: () => ({})
        },
        destination: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            filtersInitialized: false
        }
    },
    computed: {
        isVisible() {
            return this.visible
        },
        ...mapGetters({
            getFeFiltersforSearchPayload: 'getFeFiltersforSearchPayload',
            getFEUser: 'getFEUser',
            getFEOffers: 'getFEOffers'
        }),
        // Sprint 19: reader granulare dal Config Bus.
        ...mapConfig(['freightExchangeLastSearch']),
        // True quando il blob user è stato idratato dal backend (config/load). Stessa
        // semantica del vecchio guard `Object.keys(config).length > 0` sul blob intero,
        // ma senza deep-watch: Object.keys si invalida solo all'aggiunta/rimozione di
        // chiavi (Vue.set in SET_VALUE/HYDRATE), non alle mutazioni interne dei valori.
        configHydrated() {
            return Object.keys(this.$store.state.config.user).length > 0
        }
    },
    watch: {
        configHydrated: {
            handler(hydrated) {
                // Inizializza i filtri una sola volta, appena la config è disponibile
                if (hydrated && !this.filtersInitialized) {
                    this.initializeFiltersFromConfig()
                    this.filtersInitialized = true
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions({
            initializeFiltersFromConfig: 'initializeFiltersFromConfig',
            setAndLoadFEOffers: 'setAndLoadFEOffers',
            saveFELastSearch: 'saveFELastSearch'
        }),
        ...mapMutations({
            setLoading: 'setLoading',
            // Aggiorna i filtri nello store SOLO in memoria (senza persistenza)
            setFEFilters: 'setFEFilters'
        }),

        // Metodo helper per ottenere gli headers comuni
        getRequestHeaders() {
            return {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                authorization: 'Bearer ' + this.getFEUser.token
            }
        },

        // Metodo helper per creare o aggiornare una ricerca
        async createOrUpdateSearch(filters) {
            const searchId = this.freightExchangeLastSearch?.id
            const url = `${this.$env.GOLIA_EXCHANGE_API}/v1/shipment-searches${searchId ? `/${searchId}` : ''}`

            const response = await fetch(url, {
                method: searchId ? 'PUT' : 'POST',
                body: JSON.stringify(filters),
                headers: this.getRequestHeaders()
            })

            // Se ricevi 404 su PUT, ricrea la ricerca con POST
            if (response.status === 404) {
                const newResponse = await fetch(`${this.$env.GOLIA_EXCHANGE_API}/v1/shipment-searches`, {
                    method: 'POST',
                    body: JSON.stringify(filters),
                    headers: this.getRequestHeaders()
                })
                return newResponse.json()
            }

            return response.json()
        },

        // Metodo helper per aggiornare le offerte
        async refreshOffers(searchId) {
            const response = await fetch(
                `${this.$env.GOLIA_EXCHANGE_API}/v1/shipment-searches/${searchId}/refresh`,
                {
                    headers: this.getRequestHeaders()
                }
            )
            return response.json()
        },

        async handleClick(event) {
            // Se il controllo è disabilitato, mostra un toast di avviso
            if (this.disabled) {
                this.$snotify.info(this.__('freight_exchange.zoom_to_search'), {
                    position: 'centerTop',
                    timeout: 3000
                })
                return
            }

            if (!this.isVisible || this.getFEUser === 401) return

            try {
                this.setLoading(true)

                // Se disponibili, usa esclusivamente i valori correnti della form:
                // li sincronizziamo nello store in memoria così il getter
                // `getFeFiltersforSearchPayload` applica anche il formato date/tz.
                if (this.formFilters && Object.keys(this.formFilters).length > 0) {
                    this.setFEFilters(this.formFilters)
                }

                // Prepara i filtri (derivati dai filtri correnti nello store)
                const filters = this.getFeFiltersforSearchPayload || {}
                const name = JSON.stringify(this.location.lat) + this.location.lng
                let radius = this.location.radius / 1000
                radius = Math.max(1, Math.min(50, parseInt(radius)))

                filters.search_points = [
                    {
                        position: 1,
                        radius: radius,
                        data: [name],
                        name: name,
                        lat: this.location.lat,
                        long: this.location.lng,
                        type: 'loading'
                    }
                ]

                if (this.destination) {
                    filters.search_points.push({
                        position: 2,
                        radius: this.destination.radius,
                        data: [this.destination.name],
                        name: this.destination.name,
                        lat: this.destination.lat,
                        long: this.destination.lng,
                        type: 'unloading'
                    })
                }

                // Crea o aggiorna la ricerca
                const searchResult = await this.createOrUpdateSearch(filters)

                // Salva l'ID della ricerca se disponibile
                if (searchResult?.data?.id) {
                    await this.saveFELastSearch({
                        lastSearch: { id: searchResult.data.id },
                        vueInstance: this
                    })

                    // Aggiorna le offerte
                    const refreshResult = await this.refreshOffers(searchResult.data.id)

                    if (refreshResult?.data?.offers) {
                        this.setAndLoadFEOffers(refreshResult.data.offers)
                    }
                }
            } catch (error) {
                console.error('Errore durante la ricerca:', error)
            } finally {
                this.setLoading(false)
            }
        }
    }
}
</script>

<style scoped>
.freight-exchange-control {
    width: 36px;
    height: 36px;
    text-decoration: none;
    border-radius: 12px !important;

    &:hover {
        background-color: var(--bs-gray-300) !important;
    }
}

.fe-indicator {
    background: var(--success);
    min-width: 20px;
    display: inline-block;
    min-height: auto;
    padding: 0px 5px;
    font-size: 13px;
    font-family: Stolzl-Medium, sans-serif;
}
</style>
